var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.list.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.list, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = [1, 2].includes(_vm.status)
          var g2 = item.endDate.substring(0, 10)
          return {
            $orig: $orig,
            g1: g1,
            g2: g2,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }